module.exports = __webpack_public_path__ + "img/riot.4b00e9e4.png";